import { colorStatus } from "constants";
import { enumDecode } from "./utils";
import { deserializePhoneNumber } from "utils/common";
import { colors } from "assets/colors/colors";

export const DOCTOR_STATUS = {
  pending: "Pending",
  active: "Active",
  disabled: "Disabled",
  suspended: "Suspended",
  inviteSent: "Invite Sent",

  colorIndicator: (status) => {
    switch (status) {
      case DOCTOR_STATUS.pending:
        return colors.core40;
      case DOCTOR_STATUS.active:
        return colors.elfName;
      case DOCTOR_STATUS.disabled:
        return colors.redError;
      case DOCTOR_STATUS.suspended:
        return colors.peach;
      case DOCTOR_STATUS.inviteSent:
        return colors.core70;
      default:
        return colors.core40;
    }
  },
  displayValue: (status) => status,
  values: () => [
    DOCTOR_STATUS.pending,
    DOCTOR_STATUS.active,
    DOCTOR_STATUS.disabled,
    DOCTOR_STATUS.suspended,
    DOCTOR_STATUS.inviteSent,
  ],
  options: () => [
    ...DOCTOR_STATUS.values().map((status) => ({
      value: status,
      label: DOCTOR_STATUS.displayValue(status),
    })),
  ],
};

export const EMPLOYMENT_TYPE = {
  employee: "employee",
  contractor: "contractor",
  values: () => [EMPLOYMENT_TYPE.employee, EMPLOYMENT_TYPE.contractor],
};

export const doctorFromJson = (json) => {
  return {
    uuid: json.uuid,
    firstName: json.first_name,
    lastName: json.last_name,
    phoneNumber: deserializePhoneNumber(json.phone_number),
    specialty: json.specialty,
    email: json.email,
    region: json.region,
    uploadedFileCount: json.uploaded_files_number,
    validationStatus: enumDecode(DOCTOR_STATUS, json.validation_status),
    employeeType: enumDecode(EMPLOYMENT_TYPE, json.employee_type),
  };
};
